module.exports = __webpack_public_path__ + "img/tree-05-i-leaves.79b12cba.png";